import React, {useState} from 'react';
import Select from 'react-select';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const FobContainerCanton = ({toggleVisibilityFob, isVisibleFob, fobData, handleChangeFob, selectedFob, commentFob, commentTextAreaRefFob,
      handleCommentChangeFob, toggleFobMarker, fobMarker, fobSave, rankComponentData, handleChangeRankComponentFob, selectedRankFob}) => {

  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <React.Fragment>
      <button onClick={toggleVisibilityFob} className={isVisibleFob ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisibleFob ? 'Фоб: скрыть' : 'Фоб: показать'}
      </button>
      {isVisibleFob && (
        <div className='divСommunicationsDrawer'>
         {selectedRankFob === '1' || selectedRankFob === '2' ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}
          <label className='textTitleDrawer'>Фоб</label>
          <hr className="horizontalLineDrawer" />
          <div>
           <select className="selectStyleDrawer" style={{ marginBottom: "5px", marginTop: "10px" }} onChange={handleChangeFob} value={selectedFob}>
              <option value="null">Выберите фоб</option>
              {fobData.map(fob => (
                <option key={fob.id} value={fob.id}>{fob.name}</option>
              ))}
            </select>
            <br/>
            <select className="selectStyleDrawer" style={{ marginTop: "10px"}} onChange={handleChangeRankComponentFob} value={selectedRankFob}>
              <option value="null">Относится к узлу</option>
              {rankComponentData.map(rank => (
                <option key={rank.id} value={rank.id}>{rank.name}</option>
              ))}
            </select>

            <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <NewReleasesIcon
                  style={{
                    cursor: "pointer",
                    color: "#ebb434",
                    fontSize: "24px",
                    marginLeft: "5px",
                  }}
                />
                {showTooltip && (
                  <div className='tooltipWarning' >
                    Выберите максимальный ранг линка,<br/>
                    который присутствует в фобе.
                  </div>
                )}
              </div>
     
            <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />

          </div>
          <div >

            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentFob}
              ref={commentTextAreaRefFob}
              onChange={handleCommentChangeFob}
            />
            <button onClick={toggleFobMarker} className={fobMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {fobMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={fobSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default FobContainerCanton;